<template>
  <article
    class="a-product-grid__item item-preview"
    v-bind:class="{'a-product-grid__item--highlight item-preview--highlight': isHighlight(p)}"
    :data-item-id="entry_id"
    itemprop="itemListElement"
    itemscope=""
    itemtype="http://schema.org/Product"
    data-group-id="135">
    <figure
      class="item-preview__media skeleton img-ratio"
      v-bind:class="{'img-ratio--highlight': isHighlight(p), 'img-ratio--square': !isHighlight(p) }">
      <figcaption class="sr-only">{{ name }}</figcaption>
      <img
        v-if="!isHighlight(p)"
        itemprop="image"
        src="data:image/gif;base64,R0lGODdhCgAKAIABAPT09P///ywAAAAACgAKAAACCISPqcvtD2MrADs="
        sizes="(min-width: 768px) 33vw,50vw"
        :srcset="'/images/p/370/' + sku + '.jpg 370w,/images/p/480/' + sku + '.jpg 480w'"
        :alt="title"
        class="img-fluid"
        loading="lazy">
      <img
        v-else
        itemprop="image"
        src="data:image/gif;base64,R0lGODdhCgAKAIABAPT09P///ywAAAAACgAKAAACCISPqcvtD2MrADs="
        sizes="(min-width: 992px) 33vw, (min-width: 768px) 50vw, 100vw"
        :srcset="'/images/highlight/' + sku + '.jpg 700w'"
        :alt="title"
        class="img-fluid"
        loading="lazy">
    </figure>
    <header class="item-preview__header text-center">
      <h2 class="item-preview__title skeleton">
        <a itemprop="url" :data-ga-event-label="entry_id + ' - ' + title" :href="finalUrl" :title="description">
          <span itemprop="name" class="hidden-if-loading">{{ name }}</span>
          <span class="item-preview__title-annotation hidden-if-loading" v-if="gender_plus">
              {{ gender_plus }}
          </span>
        </a>
      </h2>
      <h3 itemprop="offers" itemscope="" itemtype="http://schema.org/Offer" class="item-preview__subtitle">
        <span class="www-price-slashed" v-if="old_price">{{ old_price }} €</span>
        <span class="www-price-discount" v-if="old_price">
                <span itemprop="price"><span class="hidden-if-loading">{{ price }}</span></span>
              </span>
        <span itemprop="price" v-else>
                <span class="hidden-if-loading">{{ price }}</span>
              </span>
        <span class="hidden-if-loading">&euro;</span>
        <meta itemprop="priceCurrency" content="EUR">
      </h3>
    </header>
    <div class="item-preview-hover">
      <a :data-ga-event-label="entry_id + ' - ' + title" :href="finalUrl" :title="copyDiscover + ' ' + name" class="item-preview-hover__more item-preview-hover__icon"><i class="ico ico-eye"></i> <span class="sr-only">{{ copyDiscover }}</span></a>
    </div>
    <a :data-ga-event-label="entry_id + ' - ' + title" :href="finalUrl" class="item-preview__faux-link www-faux-link" :title="description"></a>
  </article>
</template>

<script>
  export default {
    props: [
      'url',
      'title',
      'entry_id',
      'description',
      'old_price',
      'price',
      'gender_plus',
      'sku',
      'name',
      'status'
    ],
    methods: {
      isHighlight: function () {
        return this.status === 'highlight'
      }
    },
    computed: {
      finalUrl: function () {
        if (this.gender_plus) {
          return this.url + '?from=' + this.currentGender
        }

        return this.url
      },
      currentGender: function () {
        return this.$store.getters.currentGender
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ProductHighlight.vue